module.exports = __webpack_public_path__ + "static/media/bt_top_interestcheck_over.8e15758f.png";